module.exports = __webpack_public_path__ + "img/red-warning.87633f4c.svg";